import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import api from "../../../API";
import { useSelector } from "react-redux";

interface props {
  task: string;
  idx: number;
  setOpenJsonDialog: React.Dispatch<React.SetStateAction<boolean>>
  // setOpen:React.Dispatch<React.SetStateAction<boolean>>;
  // getMemberList:any;
}

// const SampleRejectRsnDialog = () => {
const VieJsonDialog = (props: props) => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const [formattedJson, setFormattedJson] = useState("")

  // JSON 객체를 HTML 형식으로 포맷하는 함수
  const formatJson = (obj:any) => {
    const jsonString = JSON.stringify(obj, null, 2);
    
    // 각 줄을 처리하여 HTML 형식으로 변환
    const formattedHtml = jsonString.split('\n').map((line:any) => {
        // 4칸 공백을 &nbsp;로 변환하여 들여쓰기 유지
        const indent = line.match(/^\s*/)[0].replace(/ /g, '&nbsp;'); // 공백을 &nbsp;로 변경
        // key를 빨간색으로 변환
        const lineWithColor = line.replace(/"([^"]+)":/g, '<span style="color: #ffd415;">"$1"</span>: ');
            return `${indent}${lineWithColor}`;
        }).join('<br />'); // 줄바꿈을 <br />로 변환

    return formattedHtml;
  };

  const getJson = async (task:string, idx:number) => {

    var result = await api.get("/getVieJson",{params: {email:email,task:task,idx:idx}})
    
    var datas = result.data.datas

    // JSON을 객체로 변환
    const jsonData = JSON.parse(datas);

    // JSON 객체를 문자열로 변환하면서 key와 value의 스타일을 다르게 설정
    const formattedJsonWithColors = formatJson(jsonData);

    setFormattedJson(formattedJsonWithColors);

  }

  useEffect(() => {
    getJson(props.task, props.idx);
    
  }, [props.task,props.idx]);

  return (
    <Box >
    <Dialog maxWidth="lg" open={true} fullWidth={true}>
      <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>Task.{props.task} <b style={{marginLeft:"8px"}}>({props.idx})</b> - JSON 미리보기</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ width: "1400px", margin: '12px auto' }}>
            <pre style={{
                backgroundColor: '#282c34', // 다크 배경
                color: '#8ae9fa',           // React 블루 계열
                padding: '20px',            // 안쪽 여백
                borderRadius: '8px',        // 모서리 둥글게
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', // 그림자 효과
                fontFamily: 'Courier New, Courier, monospace', // 모노스페이스 폰트
                whiteSpace: 'pre-wrap',     // 텍스트 줄바꿈
                wordBreak: 'break-word',    // 긴 단어 줄바꿈
                overflowX: 'auto'           // 가로 스크롤 허용
            }}>
                <div dangerouslySetInnerHTML={{ __html: formattedJson }} />
            </pre>
        </Box>
        {/* </form> */}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            props.setOpenJsonDialog(false);
          }}
        >
          취소
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
};

export default VieJsonDialog;
